<template>
<div>
  <van-notice-bar color="#ffffff" background="#f73131" left-icon="info-o" v-show="thyy">
    退回原因：{{thyy}}
  </van-notice-bar>
  <div class="content">
    <van-form @submit="onSubmit">
    <div>

        <van-cell-group>
          <van-field v-model="yybh" label="预约编号" readonly   input-align="right"/>
          <van-field v-model="chetouhao" label="车头号" readonly   input-align="right"/>
          <van-field v-model="cheguahao" label="车挂号" readonly   input-align="right"/>
          <van-field v-model="yyqssj" label="预约起始时间" readonly   input-align="right"/>
          <van-field v-model="yyzzsj" label="预约终止时间" readonly   input-align="right"/>
        </van-cell-group>
        <div class="fill-box"></div>
        <van-cell-group>
          <van-field v-model="jsyname" label="驾驶员姓名" readonly   input-align="right"/>
          <van-field v-model="jsysfz" label="驾驶员身份证" readonly   input-align="right"/>
          <choseTimeHour :timeVmodel="jsyhssj" :timeName="jsyhssj" timeLabel="驾驶员核酸时间" @getYxq="getJsyhssj" :timeValue="jsyhssj_time" />

          <van-field name="radio" label="驾驶员核酸结果" required  input-align="right" label-width="10rem">
            <template #input>
              <van-radio-group v-model="yyyhsjg" direction="horizontal">
                <van-radio name="1">阴性</van-radio>
                <van-radio name="2">阳性</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <div class="upload-pic">
            <h2 class="upload-titile input-title-hq red-required">驾驶员核酸图片</h2>
            <div class="upload-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsyhspic_image" :before-read="beforeRead" :after-read="uploadPicHsJsy" :before-delete="deletePicHsJsy"></van-uploader>
            </div>
          </div>
        </van-cell-group>

        <div class="fill-box"></div>
        <van-cell-group>
          <van-field v-model="yyyname" label="押运员姓名" readonly   input-align="right"/>
          <van-field v-model="yyysfz" label="押运员身份证" readonly   input-align="right"/>
          <choseTimeHour :timeVmodel="yyyhssj" :timeName="yyyhssj" timeLabel="押运员核酸时间" @getYxq="getYyyhssj" :timeValue="yyyhssj_time" />

          <van-field name="radio" label="押运员核酸结果" required  input-align="right" label-width="10rem">
            <template #input>
              <van-radio-group v-model="jsyhsjg" direction="horizontal">
                <van-radio name="1">阴性</van-radio>
                <van-radio name="2">阳性</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <div class="upload-pic">
            <h2 class="upload-titile input-title-hq red-required">押运员核酸图片</h2>
            <div class="upload-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="yyyhspic_image" :before-read="beforeRead" :after-read="uploadPicHsYyy" :before-delete="deletePicHsYyy"></van-uploader>
            </div>
          </div>
        </van-cell-group>

    </div>

    <div style="margin: 1rem;" v-if="shzt == '0'">
      <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#316892">
        提交
      </van-button>
    </div>
    </van-form>
  </div>

  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from '@/fetch/api';
import {
  Toast,
  Dialog
} from 'vant';
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
import choseTimeHour from '../Public/choseTimeHour.vue'
export default {
  components: {
    Tabbar,
    choseTimeHour
  },
  created() {
    document.title = "上传核酸结果";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getyyzbhsbg(id);
  },
  data() {
    return {
      detail: [],
      loadingBtn: false,
      yybh: "",
      thyy: "",
      chetouhao: "",
      cheguahao: "",
      yyqssj: "",
      yyzzsj: "",
      jsyname: "",
      jsysfz: "",
      jsyhssj: "",
      jsyhssj_time: "",
      jsyhsjg: "1",
      jsyhspic_image: [],
      jsyhspic_url:"",

      yyyname: "",
      yyysfz: "",
      yyyhssj: "",
      yyyhssj_time: "",
      yyyhsjg: "1",
      yyyhspic_image: [],
      yyyhspic_url:"",
      ctid:0,
      shzt:"0",
    };
  },

  methods: {
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    getyyzbhsbg(id) {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      api.getyyzbhsbg(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.$data.ctid = detail.id;
          that.$data.yybh = detail.yybh;
          that.$data.shzt = detail.shzt;
          //detail.thyy = "图片上传错误图片上传错误图片上传错误图片上传错误";
          that.$data.thyy = detail.thyy?detail.thyy:"";
          that.$data.chetouhao = detail.chetouhao;
          that.$data.cheguahao = detail.cheguahao;
          that.$data.yyqssj = detail.yyqssj;
          that.$data.yyzzsj = detail.yyzzsj;
          that.$data.jsyname = detail.jsyname;
          that.$data.jsysfz = detail.jsysfz;
          that.$data.jsyhssj_time = detail.jsyhssj;
          that.$data.jsyhsjg = (detail.jsyhsjg == "阳性")?"2":"1";

          that.$data.yyyname = detail.yyyname;
          that.$data.yyysfz = detail.yyysfz;
          that.$data.yyyhssj_time = detail.yyyhssj;
          that.$data.yyyhsjg = (detail.yyyhsjg == "阳性")?"2":"1";

          that.$data.jsyhspic_url = detail.jsyhspic ? detail.jsyhspic : "";
          that.$data.yyyhspic_url = detail.yyyhspic ? detail.yyyhspic : "";
          that.$data.jsyhspic_image = detail.jsyhspic ? [{
            url: weburl + '/' + detail.jsyhspic
          }] : [];
          that.$data.yyyhspic_image = detail.yyyhspic ? [{
            url: weburl + '/' + detail.yyyhspic
          }] : [];
        }
      }).catch(function() {
        //console.log(err);
      });
    },
    getJsyhssj(time) {
      this.$data.jsyhssj_time = time;
    },
    getYyyhssj(time) {
      this.$data.yyyhssj_time = time;
    },
    uploadPicHsJsy(file)
    {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("sjid", that.ctid);
      let type = "jsy";
      api.uploadPicHs(type,formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsyhspic_image = [{
            url: weburl + '/' + imageData.jsyhspic
          }];
          that.$data.jsyhspic_url = imageData.jsyhspic ? imageData.jsyhspic : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadPicHsYyy(file){
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("sjid", that.ctid);
      let type = "yyy";
      api.uploadPicHs(type,formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.yyyhspic_image = [{
            url: weburl + '/' + imageData.yyyhspic
          }];
          that.$data.yyyhspic_url = imageData.yyyhspic ? imageData.yyyhspic : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deletePicHsJsy() {
      this.$data.jsyhspic_image = [];
      this.$data.jsyhspic_url = "";
    },
    deletePicHsYyy() {
      this.$data.yyyhspic_image = [];
      this.$data.yyyhspic_url = "";
    },
    //提交表单
    onSubmit(values) {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var yybh = that.$data.yybh;
      var jsyhssj_time = that.$data.jsyhssj_time;
      var yyyhssj_time = that.$data.yyyhssj_time;
      // var jsyhspic_image = that.$data.jsyhspic;
      // var yyyhspic_image = that.$data.yyyhspic;
      var jsyhspic_url = that.$data.jsyhspic_url;
      var yyyhspic_url = that.$data.yyyhspic_url;

      var jsyhsjg = (values.jsyhsjg == "2")?"阳性":"阴性";
      var yyyhsjg = (values.yyyhsjg == "2")?"阳性":"阴性";
      // console.log(jsyhspic_image);
      // console.log(yyyhspic_image);
      // console.log(jsyhssj_time);
      // console.log(yyyhssj_time);
      // console.log(jsyhsjg);
      // console.log(yyyhsjg);
      if (!jsyhspic_url) {
        Toast.fail('请上传驾驶员核酸结果');
        return false;
      }
      if (!yyyhspic_url) {
        Toast.fail('请上传押送员核酸结果');
        return false;
      }

      that.$data.loadingBtn = true;

      var formData = JSON.stringify({
        id:that.ctid,
        openid: openid,
        jsyhspic: jsyhspic_url,
        yyyhspic: yyyhspic_url,
        jsyhssj: jsyhssj_time?jsyhssj_time+":00":"",
        yyyhssj: yyyhssj_time?yyyhssj_time+":00":"",
        jsyhsjg: jsyhsjg,
        yyyhsjg: yyyhsjg,
        yybh: yybh,
      });

      api.uploadHsResult(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'orderlist'
            })
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  margin: 1rem 0 3.75rem;
  padding-bottom: env(safe-area-inset-bottom);
    .fill-box {
        width: 100%;
        height: 1rem;
        background: rgb(248,248,248);
    }
    .addBtn {
        background: #316892;
    }
    .upload-box {
        margin-top: 1rem;
        margin-left: 1rem;
        .upload-box__title {
            padding: 1rem 0;
        }
    }
}
.upload-pic {
    background: #fff;
    .upload-titile {
        padding: 0.675rem 1rem 0;
    }
    .upload-box {
        margin-left: 1rem;
    }
}
</style>
